export enum AlertSubjects {
  Global = 'global',
  Map = 'map',
  Form = 'form',
  Photo = 'photo',
  Network = 'network',
  Authentication = 'authentication',
  Cache = 'cache',
  PlanMyTrip = 'plan my trip'
}

export enum AlertSeverity {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}
